export function SelectFeatures(state = false, action) {
  switch (action.type) {
    case 'SET_SELECT_FEATURES': {
      return action.payload
    }
    default:
      return state
  }
}
